import type { SVGProps } from "react";
import * as React from "react";

export const PenAndBookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    className="fill-current"
    {...props}
  >
    <g
      fill="currentColor"
      clipPath="url(#pen-and-book_svg__a)"
    >
      <path d="M8.507 11.519s-.037.04-.048.064l-1.355 3.523c-.16.527-.055.703.091.86.137.147.35.277.872.127l3.54-1.072s.061-.023.103-.062l5.333-4.956-3.198-3.445zM18.86 5.083a2.28 2.28 0 0 0-1.627-.737c-.623-.022-1.258.179-1.68.626l-.937.864 3.199 3.445.921-.85c.472-.44.72-.994.743-1.673.022-.613-.179-1.254-.625-1.676z" />
    </g>
    <path
      fill="currentColor"
      d="M12.503 2.783v-.78l-10.5.003V18h10.498v-1.498a1.002 1.002 0 0 1 2.004 0v2.5c0 .552-.45 1-1.002 1H1.002a1 1 0 0 1-1.002-1V1.003C0 .45.449.002 1.002.002L13.505 0c.553 0 1.001.449 1.001 1.002v1.781a1.002 1.002 0 0 1-2.003 0"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={2}
      d="M5.008 6h5.5M5.008 10h1.5M5.008 14.004V14"
    />
    <defs>
      <clipPath id="pen-and-book_svg__a">
        <path
          fill="currentColor"
          d="m7.43 4 12.137.427-.426 12.137-12.138-.426z"
        />
      </clipPath>
    </defs>
  </svg>
);
